module.exports = __webpack_public_path__ + "img/schoolLogo.3e63290c.png";